export default (minLength, maxLength, errorMessage) => (value) =>
  (value.length && value.length >= minLength && value.length <= maxLength) ||
  errorMessage
